import { lazy } from "react";

// lazy() that also exposes a .preload() so we can warm the chunk on hover / idle,
// removing the blank Suspense flash when switching pages.
export function lazyWithPreload(factory) {
  const Comp = lazy(factory);
  Comp.preload = factory;
  return Comp;
}
